<div class="eiq-input__container">
  <span class="fs__sm fw__500 label">
    {{ label() }}
    @if (!(control.invalid && control.touched) && hint()) {
      <span class="fs__xs caption">{{ hint() }}</span>
    }
    @if (tooltip()) {
      <fa-icon [icon]="faInfoCircle" class="caption" [matTooltip]="tooltip()"></fa-icon>
    }
  </span>
  <mat-form-field appearance="outline" class="eiq-input__field" [ngClass]="color()" [subscriptSizing]="holdRequiredPlaceholder()">
    @if (prefix()) {
      <span matPrefix>{{ prefix() }}</span>
    }
    @if (suffix()) {
      <span matSuffix class="text__md">{{ suffix() }}</span>
    }
    <input
      matInput
      #input
      [type]="type()"
      [eiqAutoFocus]="autofocus()"
      autocomplete="false"
      [placeholder]="placeholder()"
      [value]="currentValue"
      [formControl]="control"
      [maxlength]="maxLength()"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.data-testid]="testId() ? testId() + '-input' : null"
      (input)="setValue($event)"
      (keydown)="onKeyDown($event)"
      (keyup.enter)="keyupEnter.emit()"
      (focus)="handleFocus()"
      (blur)="handleBlur()"
    />

    <div class="eiq-input__container__error">
      <mat-error><eiq-validation-text [formCtrl]="control"></eiq-validation-text></mat-error>

      @if (maxLength()) {
        <mat-hint class="fs__sm fw__400">{{ input?.value.length || 0 }}/{{ maxLength() }}</mat-hint>
      }
    </div>
  </mat-form-field>
  @if (!(control.invalid && control.touched) && descriptionHint()) {
    <mat-hint class="fs__sm caption">{{ descriptionHint() }}</mat-hint>
  }
</div>
